// src/components/Header.js
import React from 'react';
import { useHistory } from 'react-router-dom';
import umpsLogo from '../assets/umps-logo.png'; // Adjust the path if needed

const Header = ({ title }) => {
  const history = useHistory();
  const SHOW_SYSTEM_SETUP_LINK = true; 

  const handleLogout = () => {
    // Clear tokens from localStorage or other storage mechanism
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    // Redirect to the login page
    history.push('/login');
  };

  return (
    <header className="header">
      <div className="header-left">
        <img src={umpsLogo} alt="Umps Link Logo" className="portal-logo" />
      </div>
      <div className="header-center">
        <h1 className="page-title">{title}</h1>
      </div>
      <div className="header-right">
        <nav className="header-nav-links" style={{ display: 'inline', marginRight: '1rem' }}>
          <a href="/devices" onClick={e => { e.preventDefault(); history.push('/devices'); }} className="header-link subtle-link">Hubs</a>
          <span style={{ margin: '0 0.5rem', color: '#bbb' }}>|</span>
          <a href="/pendants" onClick={e => { e.preventDefault(); history.push('/pendants'); }} className="header-link subtle-link">Pendants</a>
          {SHOW_SYSTEM_SETUP_LINK && (
            <>
              <span style={{ margin: '0 0.5rem', color: '#bbb' }}>|</span>
              <a href="/system-setup" onClick={e => { e.preventDefault(); history.push('/system-setup'); }} className="header-link subtle-link">System Setup</a>
            </>
          )}
        </nav>
        <button className="logout-button" onClick={handleLogout}>Logout</button>
      </div>
    </header>
  );
};

// Add subtle-link CSS for subtle navigation links
// You may want to move this to your main CSS file
const style = document.createElement('style');
style.innerHTML = `
  .subtle-link {
    font-size: 0.95em;
    color: #888;
    text-decoration: none;
    margin: 0 0.2em;
    transition: color 0.2s;
  }
  .subtle-link:hover {
    color: #555;
    text-decoration: underline;
  }
`;
document.head.appendChild(style);

export default Header;
